import React from 'react';

interface Props {
    dt: Date
}

export const ChatMessageListDayDivider = ({dt}: Props) => {
    const formatDate = (dt: Date) => {
        const date = dt.getDate(),
            diffDays = new Date().getDate() - date,
            diffMonths = new Date().getMonth() - dt.getMonth(),
            diffYears = new Date().getFullYear() - dt.getFullYear();

        if (diffYears === 0 && diffDays === 0 && diffMonths === 0) {
            return 'Сегодня';
        } else if (diffYears === 0 && diffDays === 1) {
            return 'Вчера';
        } else {
            return dt.toLocaleDateString();
        }
    };

    return (
        <div className='text-melon-grey-darker text-center px-5 py-1'>
            {formatDate(dt)}
        </div>
    );
};
